import { APP_ERROR, CLEAR_SEARCH, DONT_CLEAR, SEARCH_QUERY } from '../constants/app'

export const showError = (err) => {
  return {
    type: APP_ERROR,
    payload: err
  }
}

export const setQuery = (query) => {
  return {
    type: SEARCH_QUERY,
    payload: query
  }
}

export const clearSearch = () => {
  return {
    type: CLEAR_SEARCH,
  }
}

export const searchCleared = () => {
  return {
    type: DONT_CLEAR
  }
}
